import { FC, ReactNode } from 'react';
import { MarkdownToJSX } from 'markdown-to-jsx';
import { LinkProps, Stack, Typography } from '@mui/material';
import { Link, theme } from '@vs-online-only-app/ui';

interface Props {
  children?: ReactNode;
}

const StyledLink: FC<LinkProps> = ({ children, href, ...props }): ReactNode => {
  if (href) {
    return (
      <Link
        to={href}
        target="_blank"
        rel="noopener noreferrer"
        color="inherit"
        {...props}
      >
        {children}
      </Link>
    );
  }

  return children;
};

const Paragraph: FC = ({ children, ...props }: Props) => (
  <Typography
    {...props}
    variant="body2"
    component="span"
    sx={{ display: 'block' }}
  >
    {children}
  </Typography>
);

const Heading: FC = ({ children, ...props }: Props) => (
  <Typography {...props} fontWeight="bold" variant="body2">
    {children}
  </Typography>
);

const tagOverrides = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].reduce(
  (obj, tagKey) => ({ ...obj, [tagKey]: Heading }),
  {},
);

export const markdownOptions: MarkdownToJSX.Options = {
  disableParsingRawHTML: true,
  // forceBlock: true,
  wrapper: (props) => (
    <Stack spacing={theme.typography.body2.lineHeight} {...props} />
  ),
  overrides: {
    ...tagOverrides,
    a: StyledLink,
    p: Paragraph,
    ul: Paragraph,
    li: Paragraph,
    blockquote: Paragraph,
    span: Paragraph,
  },
};

export default markdownOptions;
